var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5028V11.7026C2 12.4493 2 12.8224 2.14532 13.1077C2.27316 13.3585 2.47698 13.5629 2.72786 13.6908C3.0128 13.8359 3.386 13.8359 4.13127 13.8359H14.0001M2 10.5028V3.83594M2 10.5028L4.56893 8.36198L4.57106 8.36027C5.03578 7.97301 5.26859 7.779 5.52103 7.7002C5.81925 7.6071 6.14047 7.62183 6.42904 7.74154C6.67367 7.84302 6.88817 8.05752 7.31717 8.48653L7.32148 8.49083C7.75714 8.9265 7.97556 9.14491 8.22411 9.24617C8.51824 9.36599 8.84569 9.37631 9.14714 9.27632C9.40271 9.19154 9.63613 8.98764 10.1029 8.57925L14 5.16927",
    stroke: "#726C6C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthIcon);
export default __webpack_public_path__ + "static/media/growthIcon.1bc7851102b34492b5f31030f2c6bc7e.svg";
export { ForwardRef as ReactComponent };